import { useContext } from "react"

import type { FollowedUsersContextValue } from "./FollowedUsersContext"
import { FollowedUsersContext } from "./FollowedUsersContext"

export function useFollowedUsers(): FollowedUsersContextValue {
  return useContext(FollowedUsersContext)
}
